
import PriceFormat from "../../../../utils/priceFormat";
import DashboardStat from "../../../dashboard/DashboardStat";
import Card from "../../../shared/Card/Card";
import useListingStats from '../../../../data/useListingStats';
import ListedStatsTable from "./ListedStatsTable";
import ListedMissingTable from "./ListedMissingTable";

export function ListedTableStats() {
  const { listingStats } = useListingStats();

  if (listingStats.isLoading) return null;

  const stats = listingStats.data?.data;

  if (!stats) return null;

  return (
    <Card bodyClassName="p-4 grid grid-cols-1 lg:grid-cols-3 gap-4" title="Listing Stats" collapsible >

      {/* Column 1: General Stats */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        <DashboardStat title={stats.totalActive?.toString()} desc={"Total Active"} color={"blue"} />
        <DashboardStat title={Math.round(stats.averageAge)?.toString()} desc={"Average Age (Days)"} color={"orange"} />
        <DashboardStat title={stats.over30DaysOld?.toString()} desc={"Over 30 Days Old"} color={"yellow"} />
        <DashboardStat title={stats.over90DaysOld?.toString()} desc={"Over 90 Days Old"} color={"red"} />
        <DashboardStat title={PriceFormat(stats.averagePrice)} desc={"Average Price"} color={"green"} />
        <DashboardStat title={PriceFormat(stats.totalPrice)} desc={"Total Price"} color={"purple"} />
      </div>

      {/* Columns 2-3: Tiled Section with 2 Tables */}
      <div className="flex flex-col gap-2 lg:col-span-2">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <ListedMissingTable listingStats={stats} />
          <ListedStatsTable listingStats={stats} />
        </div>
      </div>

    </Card>
  )
}

